import React, { useEffect, useState } from "react";
// import Cross from "../../../Assets/Img/Group 208.png";
import PersonalInfo from "./Personalinfo";
import PostData from "../../../Api/PostData";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2'
import './style.css'
import GetData from "../../../Api/GetData";
import { Upload, message } from 'antd';
import analytics from '../../../firebase.config'
import { getAnalytics, logEvent } from "firebase/analytics";
import Icon from '@ant-design/icons';
import Disclaimer from "../../Atoms/Disclaimer";
const TellUsMore = ({
    handleDrctChange,
    prevStep,
    nextStep,
    handleChange,
    values,
}) => {
    const [sendingSaveReq, setsendingSaveReq] = useState(false);
    const [showErrorScreen, setShowErrorScreen] = useState(false);
    const [backAndContinueBtnStatus, setBackAndContinueBtnStatus] = useState(false);

    const [error, setError] = useState(false);
    //  useEffect = (() => {
    //     handleContinueBtn()
    // })
    var remitanceValue;
    var remitanceName;
    useEffect(() => {
        window.scrollTo(0, 0)
        // SaveSubmit('continue')
    }, [])

    const handleWhatsapp = () => {
        window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
    }
    const history = useNavigate();
    var signedEmail = JSON.parse(localStorage.getItem("user")).email;
    var moveToOtpScreenOtpRejected = localStorage.getItem("editFormStatusForReturnOnOtp")
    var editFormStatus = localStorage.getItem("editFormStatus");
    var CNICFileBackName;
    var CNICFileFrontName;
    var sendSalerySlipName1;
    const openSaveExitModel = () => {

        Swal.fire({
            title: 'You’re almost there!',
            text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#e5386a',
            // cancelButtonColor: '#d33',
            cancelButtonText: "Continue",
            // showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: 'Exit',
            // denyButtonText: `Don't save`,
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        }).then((result) => {

            if (result.isConfirmed == true) {

                if (moveToOtpScreenOtpRejected == 'true' || editFormStatus == 'true') {
                    history("/Otp");
                }
                else {
                    history("/");
                }

            }

        })

    };

    const handelExistBtn = () => {
        logEvent(analytics, 'aof_elig_ineligible_press_exit');
        history('/')
    }

    const handleBackBtn = () => {
        logEvent(analytics, 'aof_elig_ineligible_press_back');

        setShowErrorScreen(false)
    }


    const SaveSubmit = (paramVal) => {
        if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
            remitanceValue = "7";
            remitanceName = 'Resident Pakistani'
        }
        else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
            if (values?.BasisOfRemittance?.value == 1) {
                remitanceValue = "1"
                remitanceName = "Yes, I'll do this (Repatriable)"
            }
            else {
                remitanceValue = "2"
                remitanceName = "No, I won't do this (Non-Repatriable)"
            }
        }
        else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
            if (values?.BasisOfRemittance?.value == 1) {
                remitanceValue = "3"
                remitanceName = "Yes, I'll do this (Repatriable)"
            }
            else {
                remitanceValue = "4"
                remitanceName = "No, I won't do this (Non-Repatriable)"
            }
        }
        else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
            if (values?.BasisOfRemittance?.value == 1) {
                remitanceValue = "5"
                remitanceName = "Yes, I'll do this (Repatriable)"
            }
            else {
                remitanceValue = "6"
                remitanceName = "No, I won't do this (Non-Repatriable)"
            }
        }

        localStorage.setItem("save&exist", "true");
        if (paramVal == 'save') {
            setsendingSaveReq(true)
            logEvent(analytics, 'aof_elig_press_save_and_exit');
        }
        else {
            setBackAndContinueBtnStatus(true)
            logEvent(analytics, 'aof_elig_press_continue');
        }

        submitForm(paramVal)


    };
    const submitForm = (paramVal) => {


        let params = {
            uid: JSON.parse(localStorage.getItem("user"))?.user_id,
            status: false, // status true for submition and false for save and exist

            // below section for Personal  Detail
            RelationUS: values?.USResident,
            NonRelationUSPAK: values?.TaxPayer,
            RelationOrganization: values?.AssoiciatedEmployee,
            EarnIncome: values?.EarnIncome,
            ACCOUNT_TYPE: values?.Type?.value,
            ACCOUNT_TYPE_KEY: values?.Type?.children,
            //ACCOUNT_TYPE: 'NKA',
            //ACCOUNT_TYPE_KEY: 'Normal Account',



            SALUTATION: values?.Salutations.value,
            SALUTATION_KEY: values?.Salutations?.children?.toUpperCase(),
            firstName: values?.firstName,
            lastName: values?.lastName,
            GENDER: values?.Gender,
            MARITAL_STATUS: values?.MaritalStatus,
            RELATIONSHIP1: values?.Relation?.value,
            RELATIONSHIP1_KEY: values?.Relation?.children,
            FATHER_HUSBAND_NAME: values?.RelativeName,
            PLACE_OF_BIRTH: values?.placeOfBirth,
            DATE_OF_BIRTH: values?.BirthDay,
            NATIONALITY: values?.Citizenship?.value,
            NATIONALITY_KEY: values?.Citizenship?.children,
            residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
            RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
            // Residential Adddrss feilds start
            PERMANENT_ADDRESS_1: values?.Apt,
            PERMANENT_ADDRESS_2: values?.street,
            // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
            // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,
            PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
            MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,

            // Xb: obj ,


            // Mailing Adddrss feilds start
            Xd: values?.MailingAddress == false ? "true" : "false",
            MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
            MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,
            // MAILING_ADDRESS_3: values?.mailCountry?.iso3 ? values?.mailCountry?.iso3 : "",




            COUNTRY: values?.MailingAddress == false ?
                (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
                    values?.mailCountry?.iso3 : values?.mailCountry?.iso2
                : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




            // COUNTRY_KEY: values?.country?.label || values?.country?.children,
            COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,




            CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
                (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

                (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





            CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


            PROVINCE_STATE: values?.MailingAddress == false ?

                ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
                    ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


                : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

            PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
            OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
            OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
                ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

                (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





            // permanent country list

            PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
            COUNTRY1_KEY: values?.country?.label || values?.country?.children,
            PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
            PROVINCE_KEY: values?.Provinces?.label,
            PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
            PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

            PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
            PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
            EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",













            // Mailing Adddrss feilds End

            email: values?.email ? values?.email : signedEmail,
            // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),


            PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number?.slice(-12),
            PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
            relationWithMobileNo: values?.CellPhone,
            number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number?.slice(-12),
            // number: "03" + values?.Number.slice(-9),


            RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
            RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',

            RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
            relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',
            RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : '',

            PROOF_OF_ADDRESS: values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : '',
            PROOF_OF_ADDRESS_TYPE: values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "",

            PROOF_OF_ADDRESS_MAILING: values.MailingProofRelationFileName ? values.MailingProofRelationFileName : '',
            PROOF_OF_ADDRESS_MAILING_TYPE: values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : '',



            // RELATIVE_PROOF: values.ProofRelationFileName,
            // NAME_NMN: values?.NomineeName,
            // IDENTIFICATION_NMN: values?.NomineeIDType,
            // RELATIONSHIP_NMN: values?.NomineeRelation?.value,
            // RELATIONSHIP_NMN_KEY: values?.NomineeRelation?.children,
            // CNIC_NMN: values?.NomineeIDNumber,
            // CNIC_ISSUE_DATE_NMN: values?.NomineeIssueDate,
            // CNIC_EXPIRY_DATE_NMN: values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate,
            // CNIC_LIFETIME_NMN: values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false",
            NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
            IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
            RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
            RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
            CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
            CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
            CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
            CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

            // *********************   below section for Income Detail  ***************************************
            idType: values?.IDType,
            CNIC: values?.CNIC,
            issueDate: values?.IssueDate,
            DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
            LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
            IBAN: values.IBAN,
            BANK_NAME: values?.BankName,
            // employmentStatus: values.EmploymentStatus,
            EMPLOYER_NAME: values?.CompName,
            OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
            OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
            JOB_TITLE: values?.JobTitle,
            Department: values?.Department,
            OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
            // for Now Employee Apartment is removed from income detail section
            // employeeApt:values?.EmployApt,

            GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
            GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
            ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
            ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
            Remittance: remitanceValue,
            RemittanceKey: remitanceName,
            // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
            // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",

            SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
            UKN: values?.UKN,
            MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,

            // ************************* below Section for Documentations *****************************************


            CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : CNICFileFrontName ? CNICFileFrontName : "",

            CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : CNICFileBackName ? CNICFileBackName : "",
            ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : sendSalerySlipName1 ? sendSalerySlipName1 : "",

            //  below Section for Terms and conditions
            TERMS_CONDITIONS: "Y", //what to send in this?





            // Not found for following


            proofofRelationship: "",
            Client_Code: "",
            TELEPHONE_OFFICE: "",
            TELEPHONE_RESIDENCE: "",
            FAX: "",
            // PERMANENT_COUNTRY: values?.mailCountry?.value,

            PERMANENT_TELEPHONE_OFFICE: "",
            PERMANENT_TELEPHONE_RESIDENCE: "",
            PERMANENT_FAX: "",
            // OTHER_OCCUPATION: "",
            EMP_ADD_PROOF: "",
            SIGNATURE_PROOF: "",
            // TERMS_CONDITIONS: "",
            ProofofIBAN: "",
            // ZAKAAT_DECLARATION: "",
            // Remittance: "",

            // These are to be send empty for Now
            Salutation_ATR: "",
            CLIENT_NAME_ATR: "",
            IDENTIFICATION_ATR: "",
            CNIC_ATR: "",
            CNIC_EXPIRY_DATE_ATR: "",
            CNIC_LIFETIME_ATR: "",
            Mobile_ATR: "",
            Email_ATR: "",
            Mailing_ADDRESS_ATR_1: "",
            Mailing_ADDRESS_ATR_2: "",
            Mailing_ADDRESS_ATR_3: "",
            Mailing_Country_ATR: "",
            Mailing_Province_ATR: "",
            Other_Mailing_Prov_ATR: "",
            Mailing_CITY_ATR: "",
            Other_Mailing_CITY_ATR: "",
            Landline_ATR: "",
            FAX_ATR: "",
            COMP_STATUS: "false"

        };


        axios
            .post("account-details/", params)
            .then((value) => {
                // setsendingReq(false);
                setsendingSaveReq(false)
                setBackAndContinueBtnStatus(false)
                if (paramVal == 'save') {
                    if (value.data) {
                        openSaveExitModel();
                    }
                }
                else {

                    nextStep()
                }

            })
            .catch(function (error) {
                // setsendingReq(false);
                console.log(error.response);
            });

    }

    const handleContinueBtn = (e) => {
        e?.preventDefault();


        if (values?.USResident == 'Y' || values?.TaxPayer == "Y" || values?.AssoiciatedEmployee == 'Y' || values?.EarnIncome == 'N') {
            setShowErrorScreen(true)
        }
        else {
            SaveSubmit('continue')
        }


    }
    return (
        <div className="container-fluid px-0 bg-grey-100 py-5">

            <PersonalInfo handleDrctChange={handleDrctChange} values={values} />
            <div className="container px-0">
                <div className="mt-80">
                    <div className="px-3">
                        <div className="row my-5">
                            <div className="col-sm-12">
                                <div className="d-inline-flex w-100">
                                    <h1 className="fs32 ls4 fw-800 t-grey-800">Eligibility</h1>
                                </div>



                                <p className="fw-500 fs16 t-grey-500 mt16">
                                    {showErrorScreen == true ? (

                                        <>
                                            Due to the account opening being in Beta, we can't open a trading account digitally for you. This limitation will be removed once we move out of Beta. We apologize for the inconvenience. <br /> <br />
                                            Customer support can open a trading account for you through the legacy method. Please contact them on the following channels.<br /> <br />

                                            UAN: 021 111 639 825 Ext 147<br />
                                            WhatsApp:  <a className="fw-500 fs16 t-grey-500 mt16" href="#" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a> <br />
                                            Email: cs@nextcapital.com.pk

                                        </>


                                    ) : (
                                        <>
                                            Because the account opening process is in Beta some customers may not be able to open a
                                            trading account at this time. Please check your eligibility by answering the questions below. <br /> <br />

                                            This limitation will be removed once we move out of Beta.
                                        </>
                                    )}

                                </p>
                            </div>
                        </div>

                        {showErrorScreen == true ? (


                            <>

                                <form className="mt" id='AOF-form'>


                                    <hr className="t-grey-200"></hr>
                                    <div className="mb-3 pt-5 row mt150">
                                        <Disclaimer />
                                        <div className="col-lg-5 col-xl-4 text-end Half2">



                                            <button
                                                className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn text-nowrap"
                                                type='button'
                                                onClick={() => handleBackBtn()}
                                            >

                                                Back

                                            </button>

                                            <button
                                                className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                                                type="submit"
                                                onClick={() => handelExistBtn()}
                                            >
                                                Exit
                                            </button>
                                        </div>
                                        {/* <div className="col-lg-5  col-xl-4 text-end">
                                            <button
                                                className="btn-outlined fs16 px-3 py-2 mx-2"
                                                type='button'
                                                onClick={() => handleBackBtn()}
                                            >

                                                <>Back</>

                                            </button>

                                            <button
                                                className="btn-filled fs16 px-3 py-2 mx-2"
                                                type="submit"
                                                onClick={() => handelExistBtn()}
                                            >
                                                Exit
                                            </button>
                                        </div> */}


                                    </div>





                                </form>
                            </>



                        ) : (


                            <> <form onSubmit={handleContinueBtn} className="mt60" id='AOF-form'>


                                <div className="row mb-4">

                                    <div className="col-sm-1 col-md-1 mb-3">
                                        <FirstCount />

                                    </div>
                                    <div className="col-md-11">
                                        <div className="p-4 bg-white edge h-100 d-flex flex-column">
                                            <p className="fs18 fw-500 t-grey-500 Bold">Are you a U.S. resident or U.S. citizen or a U.S. green card holder or were born in the U.S.?
                                            </p>
                                            <div className="row flex11-auto mt8">
                                                <div className="col-md-6 d-flex flex-column">


                                                    <div className="col-12 col-sm-6 col-lg-4">

                                                        <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center btn-border">
                                                            <li className="w-50 br-right">
                                                                <input
                                                                    type="radio"
                                                                    id="Yes"
                                                                    name="USResident"
                                                                    value="Y"
                                                                    defaultChecked={values.USResident == "Y"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="Yes" className="btn-txt mb-0 br-right">
                                                                    Yes
                                                                </label>
                                                            </li>
                                                            <li className="w-50">
                                                                <input
                                                                    type="radio"
                                                                    id="No"
                                                                    name="USResident"
                                                                    value="N"
                                                                    defaultChecked={values.USResident == "N"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="No" className="btn-txt mb-0">
                                                                    No
                                                                </label>
                                                            </li>

                                                        </ul>
                                                    </div>



                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>






                                <div className="row mb-4">
                                    <div className="col-sm-1 col-md-1 mb-3">
                                        <SecondCount />

                                    </div>
                                    <div className="col-md-11 ">
                                        <div className="p-4 bg-white edge h-100 d-flex flex-column">
                                            <p className="fs18 fw-500 t-grey-500 Bold">
                                                Are you a taxpayer or citizen or a permanent resident of any country apart from the U.S. and Pakistan?

                                            </p>
                                            <div className="row flex11-auto mt8">
                                                <div className="col-md-6 d-flex flex-column">


                                                    <div className="col-12 col-sm-6 col-lg-4">

                                                        <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center btn-border">
                                                            <li className="w-50 br-right">
                                                                <input
                                                                    type="radio"
                                                                    id="taxYes"
                                                                    name="TaxPayer"
                                                                    value="Y"
                                                                    defaultChecked={values.TaxPayer == "Y"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="taxYes" className="btn-txt mb-0">
                                                                    Yes
                                                                </label>
                                                            </li>
                                                            <li className="w-50">
                                                                <input
                                                                    type="radio"
                                                                    id="taxNo"
                                                                    name="TaxPayer"
                                                                    value="N"
                                                                    defaultChecked={values.TaxPayer == "N"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="taxNo" className="btn-txt mb-0">
                                                                    No
                                                                </label>
                                                            </li>

                                                        </ul>
                                                    </div>







                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row mb-4">
                                    <div className="col-sm-1 col-md-1 mb-3">
                                        <ThirdCount />

                                    </div>
                                    <div className="col-md-11 mb-3 ">
                                        <div className="p-4 bg-white edge h-100 d-flex flex-column">
                                            <p className="fs18 fw-500 t-grey-500  Bold ">
                                                Do you or a close family member or somebody you are closely associated with currently hold or has ever held a post in the below listed organizations?


                                            </p>

                                            <ul className=" t-grey-200 ls5 flex11-auto">
                                                <li>Government</li>
                                                <li>Judiciary (Magistrate, District, Session, High Court or Supreme Court judge)</li>
                                                <li>Military</li>
                                                <li>State-owned corporations (OGDC, PPL, PIA, WAPDA and etc)</li>
                                                <li>Political party</li>
                                                <li>Associated with International Organizations or Non-Government Organizations (NGOs)</li>
                                                <li>Government secret agencies</li>
                                            </ul>

                                            <div className="row flex11-auto mt8">
                                                <div className="col-md-6 d-flex flex-column">


                                                    <div className="col-12 col-sm-6 col-lg-4">

                                                        <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center btn-border">
                                                            <li className="w-50 br-right">
                                                                <input
                                                                    type="radio"
                                                                    id="AssoiciatedemployeeYes"
                                                                    name="AssoiciatedEmployee"
                                                                    value="Y"
                                                                    defaultChecked={values.AssoiciatedEmployee == "Y"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="AssoiciatedemployeeYes" className="btn-txt mb-0">
                                                                    Yes
                                                                </label>
                                                            </li>
                                                            <li className="w-50">
                                                                <input
                                                                    type="radio"
                                                                    id="AssoiciatedemployeeNo"
                                                                    name="AssoiciatedEmployee"
                                                                    value="N"
                                                                    defaultChecked={values.AssoiciatedEmployee == "N"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="AssoiciatedemployeeNo" className="btn-txt mb-0">
                                                                    No
                                                                </label>
                                                            </li>

                                                        </ul>
                                                    </div>







                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-sm-1 col-md-1 mb-3">
                                        <FourCount />

                                    </div>
                                    <div className="col-md-11 mb-3 ">
                                        <div className="p-4 bg-white edge h-100 d-flex flex-column">
                                            <p className="fs18 fw-500 t-grey-500  Bold ">
                                                Do you earn an income? Example: you earn a salary, own a business, have savings, collect rental payments, earn a pension or freelance.


                                            </p>



                                            <div className="row flex11-auto mt8">
                                                <div className="col-md-6 d-flex flex-column">


                                                    <div className="col-12 col-sm-6 col-lg-4">

                                                        <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center btn-border">
                                                            <li className="w-50 br-right">
                                                                <input
                                                                    type="radio"
                                                                    id="EarnIncomeYes"
                                                                    name="EarnIncome"
                                                                    value="Y"
                                                                    defaultChecked={values.EarnIncome == "Y"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="EarnIncomeYes" className="btn-txt mb-0">
                                                                    Yes
                                                                </label>
                                                            </li>
                                                            <li className="w-50">
                                                                <input
                                                                    type="radio"
                                                                    id="EarnIncomeNo"
                                                                    name="EarnIncome"
                                                                    value="N"
                                                                    defaultChecked={values.EarnIncome == "N"}
                                                                    onChange={handleChange}
                                                                    required={true}
                                                                />
                                                                <label htmlFor="EarnIncomeNo" className="btn-txt mb-0">
                                                                    No
                                                                </label>
                                                            </li>

                                                        </ul>
                                                    </div>







                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>




                                <hr className="t-grey-200"></hr>


                                <div className="mb-3 pt-5 row">
                                    <Disclaimer />
                                    <div className="col-lg-5 col-xl-4 text-end Half2">
                                        {/* <button
                                            className="btn-outlined fs16 px-3 py-2 mx-2"
                                            type='button'
                                            onClick={() => SaveSubmit('save')}
                                           
                                        >
                                            {sendingSaveReq ? (
                                                <div className="spinner-border text-light" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                <>Save & Exit</>
                                            )}
                                        </button> */}


                                        <button
                                            className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn text-nowrap disableBtn"
                                            type='button'
                                            disabled={backAndContinueBtnStatus == true}
                                            onClick={() => SaveSubmit('save')}
                                        >
                                            {sendingSaveReq ? (
                                                // <div
                                                //   className="spinner-border t-pink"
                                                //   role="status"
                                                // >
                                                //   <span className="visually-hidden">Loading...</span>
                                                // </div>
                                                <div className="spinner">
                                                    <div className="bounce1"></div>
                                                    <div className="bounce2"></div>
                                                    <div className="bounce3"></div>
                                                </div>
                                            ) : (
                                                <>Save & Exit</>
                                            )}
                                        </button>



                                        <button
                                            // className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                                            className="btn-filled fs16 px-2 px-md-3 py-1 py-sm-2 mx-2 naviBtn disableBtn"
                                            type="submit"
                                            disabled={backAndContinueBtnStatus == true}
                                            id="tellusMore"
                                        >



                                            {backAndContinueBtnStatus ? (

                                                <div className="whitespinner">
                                                    <div className="bounce1"></div>
                                                    <div className="bounce2"></div>
                                                    <div className="bounce3"></div>
                                                </div>
                                            ) : (
                                                <>Continue</>
                                            )}


                                        </button>
                                    </div>



                                </div>





                            </form>
                            </>





                        )}














                        <p className="text-danger fs12 text-end">{error}</p>


                        <div
                            className="modal"
                            tabIndex="-1"
                            role="dialog"
                            id="SaveExitModal"
                        >
                            <div className="modal-dialog centerr" role="document">
                                <div className="modal-content">
                                    <div className="modal-header p-0">
                                        <h5 className="modal-title t-pink">Information Submited</h5>

                                        <span className="close cross">&times;</span>
                                    </div>
                                    <div className="modal-body px-0">

                                        <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                                            Thank You your information has been saved.
                                        </p>
                                    </div>
                                    <div className="modal-footer px-0">
                                        <NavLink to="/Dashboard">
                                            <button
                                                type="button"
                                                className="btn-outlined fs16 px-3 py-2 mx-2 close"
                                                data-dismiss="modal"
                                            // onClick={() => logout()}
                                            >
                                                OK
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TellUsMore;


const FirstCount = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#E5E7EB" />
        <path d="M20.2813 32.234C23.6833 32.234 25.8793 29.282 25.8793 25.142C25.8793 21.11 23.6473 18.194 20.2813 18.194C16.9153 18.194 14.6833 21.11 14.6833 25.142C14.6833 29.282 16.8793 32.234 20.2813 32.234ZM20.2813 29.354C18.8773 29.354 17.9773 27.554 17.9773 25.196C17.9773 22.856 18.8773 21.164 20.2813 21.164C21.6853 21.164 22.5853 22.856 22.5853 25.196C22.5853 27.554 21.6853 29.354 20.2813 29.354ZM32.4151 32V18.428L27.3751 18.536L26.7811 21.578L29.0131 21.506V32H32.4151Z" fill="#9DA7B7" />
    </svg>

)

const SecondCount = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#E5E7EB" />
        <path d="M17.794 32.234C21.196 32.234 23.392 29.282 23.392 25.142C23.392 21.11 21.16 18.194 17.794 18.194C14.428 18.194 12.196 21.11 12.196 25.142C12.196 29.282 14.392 32.234 17.794 32.234ZM17.794 29.354C16.39 29.354 15.49 27.554 15.49 25.196C15.49 22.856 16.39 21.164 17.794 21.164C19.198 21.164 20.098 22.856 20.098 25.196C20.098 27.554 19.198 29.354 17.794 29.354ZM35.5078 32V29.012C34.0318 29.012 32.0518 29.048 30.8278 29.066L32.1598 27.608C34.0498 25.826 35.3278 24.422 35.3278 22.334C35.3278 19.778 33.4198 18.194 30.3778 18.194C27.0838 18.194 25.3918 19.904 25.0498 23.18H28.3978C28.5418 21.866 29.1718 21.092 30.3418 21.092C31.3678 21.092 31.9438 21.758 31.9438 22.64C31.9438 23.828 31.0078 24.908 29.2978 26.744L24.3298 31.946V32H35.5078Z" fill="#9DA7B7" />
    </svg>

)

const ThirdCount = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#E5E7EB" />
        <path d="M17.8995 32.234C21.3015 32.234 23.4975 29.282 23.4975 25.142C23.4975 21.11 21.2655 18.194 17.8995 18.194C14.5335 18.194 12.3015 21.11 12.3015 25.142C12.3015 29.282 14.4975 32.234 17.8995 32.234ZM17.8995 29.354C16.4955 29.354 15.5955 27.554 15.5955 25.196C15.5955 22.856 16.4955 21.164 17.8995 21.164C19.3035 21.164 20.2035 22.856 20.2035 25.196C20.2035 27.554 19.3035 29.354 17.8995 29.354ZM30.2853 32.216C32.8413 32.216 35.4693 30.848 35.4693 27.986C35.4693 26.492 34.7133 25.34 33.3993 24.782C34.5153 24.206 35.0733 23.198 35.0733 22.01C35.0733 19.508 32.6073 18.194 30.3033 18.194C27.6033 18.194 25.7133 19.364 25.3893 22.28H28.7553C28.8633 21.326 29.3853 20.822 30.2853 20.822C31.1673 20.822 31.7613 21.38 31.7613 22.244C31.7613 23.072 31.3113 23.774 29.9793 23.774L29.7093 23.756V26.006C29.8173 25.988 29.9433 25.97 30.0693 25.97C31.4553 25.97 32.0853 26.708 32.0853 27.806C32.0853 28.85 31.3293 29.606 30.2493 29.606C29.2053 29.606 28.4493 28.958 28.3413 27.824H24.9393C25.1553 31.01 27.4593 32.216 30.2853 32.216Z" fill="#9DA7B7" />
    </svg>

)

const FourCount = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#E5E7EB" />
        <path d="M17.8028 32.234C21.2048 32.234 23.4008 29.282 23.4008 25.142C23.4008 21.11 21.1688 18.194 17.8028 18.194C14.4368 18.194 12.2048 21.11 12.2048 25.142C12.2048 29.282 14.4008 32.234 17.8028 32.234ZM17.8028 29.354C16.3988 29.354 15.4988 27.554 15.4988 25.196C15.4988 22.856 16.3988 21.164 17.8028 21.164C19.2068 21.164 20.1068 22.856 20.1068 25.196C20.1068 27.554 19.2068 29.354 17.8028 29.354ZM34.3646 26.6V18.428H31.1066L24.6266 27.23V29.39H31.1606L31.0886 32H34.3646L34.3106 29.39H35.9306V26.6H34.3646ZM31.2326 22.766C31.1966 23.252 31.1606 23.72 31.1606 24.116L31.1786 26.618L28.3166 26.654L31.2326 22.766Z" fill="#9DA7B7" />
    </svg>

)
